import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { InDevelopingImage } from '@@/common/images';

import styles from './index.module.sass';
import { useNavigate } from 'react-router-dom';

export function InDeveloping(props: IInDevelopingProps) {
  const { className, ...rest } = props;
  const rootClass = cn(className, styles.root);
  const navigate = useNavigate();
  return (
    <div className={rootClass} {...rest}>
      <div className={styles.title}>Раздел находится в разработке</div>
      <img className={styles.image} src={InDevelopingImage} alt="В разработке" />
      <span className={styles.back} onClick={() => navigate(-1)}>вернуться назад</span>
    </div>
  );
}

export interface IInDevelopingProps extends HTMLAttributes<HTMLDivElement> {}
